import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  userId: number;
  spaceId: number;
  role: string;
};

const [useUpdateSpaceMember, updateSpaceMember] = createAsyncAction(
  "spaceMembers/updateRole",
  async ({ spaceId, userId, role }: Args, thunkApi) => {
    const previousRole =
      thunkApi.getState().entities.spaceMembers.objects[`${spaceId}-${userId}`].role;
    const res = await API.call<{ member: string }>({
      endpoint: `spaces/${spaceId}/members/${userId}?include=kits`,
      method: "PUT",
      data: { role },
    });
    return { ...res, result: res.result.member, previousRole };
  }
);

export { updateSpaceMember };
export default useUpdateSpaceMember;
